<template>
    <h2>Hodnotenie predmetov</h2>
    <v-card-text>
        <div v-if="user_type == 'student'">
            <MySubjectEvaluation /> 
        </div>
        <div v-if="user_type == 'teacher'">
            <h3>Zoznam hodnotených predmetov</h3>
            <AllEvaluationResults />
        </div> 
        <v-card v-if="user_type == 'admin'">
            <h3>Administrácia</h3>
            <v-row align="center" style="margin:1px">
                <v-spacer />
                <v-btn size="small" variant="outlined" style="margin-right:1px" @click="button_selection = 1">Priradenie vyučujúcich</v-btn>
                <v-btn size="small" variant="outlined" style="margin-right:1px" @click="button_selection = 2">Celkové výsledky</v-btn>
            </v-row>    
            <SubjectAssignment v-if="button_selection == 1" /> 
            <AllEvaluationResults v-if="button_selection == 2" />
        </v-card>
    </v-card-text>
</template>

<script>
import axios from '../../axios-auth.js'
import SubjectAssignment from '../../components/subj_eval/subj_assign.vue'
import MySubjectEvaluation from '../../components/subj_eval/my_subject_evaluation.vue'
import MyEvaluationResults from '../../components/subj_eval/my_evaluation_results.vue'
import AllEvaluationResults from '../../components/subj_eval/all_evaluation_results.vue'

export default {
    data() {
        return {
            button_selection: 0,
            user_type: ''
        }
    },
    components: {
        MySubjectEvaluation,
        MyEvaluationResults,
        SubjectAssignment,
        AllEvaluationResults
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.getUserType()
        },
        getUserType() {
            axios.get('/get-evaluation-user-type', this.$store.getters.getAxiosConfig)
            .then(res => {
                this.user_type = res.data.result  
                //console.log(res.data)
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
    }
}
</script>